module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "FMH",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_vm._v("Historian’s Note")]), _vm._v(" "), _c('hr', {
    staticClass: "hr"
  }), _vm._v(" "), _c('p', {
    staticClass: "FMOT"
  }, [_vm._v("The main portion of "), _c('span', {
    staticClass: "Italic"
  }, [_vm._v("Shield of the Gods")]), _vm._v(" takes place in April 2385, shortly after "), _c('span', {
    staticClass: "Italic"
  }, [_vm._v("Star Trek: Department of Temporal Investigations—Time Lock")]), _vm._v(" and approximately four months before the dedication of the new Deep Space 9 in "), _c('span', {
    staticClass: "Italic"
  }, [_vm._v("Star Trek: The Fall—Revelation and Dust")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4c71a2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/historiansnote.vue
// module id = 72
// module chunks = 0